import { useMemo } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { ReportsPageToolbar } from 'src/components/Reports/ReportsPageToolbar';
import { ReportsSalePage } from 'src/components/ReportsSalePage';
import { Content } from 'src/contexts/ContentContext';
import { DialogProvider } from 'src/contexts/DialogContext/DialogContext';
import { WarningMessage } from 'src/core/POS/MessageWithIcon';
import { PosSpinner } from 'src/core/POS/PosSpinner';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { useReportConfigs } from 'src/hooks/useReportConfigs';
import { LayoutContent } from 'src/navigations/LayoutContent';
import { ContentId } from 'src/utils/constants/contentId';
import { ReportTypes } from 'src/utils/reportsUtils';

import { MainRoute } from '../MainRoute';
import { ReportsSaleContextProvider } from './ReportsSaleContextProvider';

export function ReportsSale() {
  return (
    <LayoutContent mainRoute={MainRoute.Reports}>
      <ReportsSaleContent />
    </LayoutContent>
  );
}

function ReportsSaleContent() {
  const { reportId } = useParams();
  const location = useLocation();

  const { reportConfigs, isLoading } = useReportConfigs<ReportTypes.Sale>({
    reportType: ReportTypes.Sale,
  });

  const reportConfig = reportConfigs?.find(
    (r) => r.reportId?.toString() === reportId
  );

  // Only use value provided at the first time (should be from '/reports')
  const returnUrl = useMemo(() => {
    return (location.state as { returnUrl?: string })?.returnUrl;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (reportConfig == null) {
    return isLoading ? (
      <PosSpinner />
    ) : (
      <Stack
        width="full"
        direction="column"
        alignItems="center"
        style={{ padding: vars.spacing.xxl }}
      >
        <WarningMessage
          message={<Content id={ContentId.ReportNotAvailable} />}
        />
      </Stack>
    );
  }

  return (
    <ReportsSaleContextProvider reportConfig={reportConfig}>
      <DialogProvider>
        <ReportsPageToolbar
          reportConfig={reportConfig}
          returnUrl={returnUrl ?? '/reports'}
        />
        <ReportsSalePage reportConfig={reportConfig} />
      </DialogProvider>
    </ReportsSaleContextProvider>
  );
}
